import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MediaModule, PageComponentModule } from '@spartacus/storefront';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { CustomBannerCarouselComponent } from './custom-banner-carousel.component';
import { CustomCarouselModule } from '../../../shared/components/custom-carousel/custom-carousel.module';

@NgModule({
    imports: [
        CommonModule, PageComponentModule, CustomCarouselModule, MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                RotatingImagesComponent: {
                    component: CustomBannerCarouselComponent,
                },
            },
        } as CmsConfig),
    ],
    declarations: [CustomBannerCarouselComponent],
    exports: [CustomBannerCarouselComponent]
})
export class CustomBannerCarouselModule {}
